<template>
  <div id="createIntention">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/intentionList?skillId='+this.tableData.skill_id +'&online='+this.online_num }">意图列表</el-breadcrumb-item>
      <el-breadcrumb-item>创建意图</el-breadcrumb-item>
    </el-breadcrumb>
    <div id="intentionInfo">
      <p class="title">创建意图</p>
      <div class="intentionContainer">
        <el-form label-width="110px" ref="rules" :rules="rules" :model="tableData">
          <el-form-item label="意图中文名" prop="chinese_name">
            <el-tooltip content="意图的中文名称(2~50个字符,仅支持中文) 保证技能内唯一" placement="top">
              <i class="icon iconfont icon-wenhao blurIcon" name="tabs" :tabindex="tabindexNumChange()" ></i>
            </el-tooltip>
            <el-input v-model.trim="tableData.chinese_name" type='text' :minlength="2" :maxlength="50"
                      placeholder="请输入中文名称" @input.native="changeRoute"></el-input>
          </el-form-item>
          <el-form-item label="意图识别名" prop="intent">
            <el-tooltip content="意图的调用名称(2~50个字符,仅支持数字,字母,下划线)保证技能内唯一" placement="top">
              <i class="icon iconfont icon-wenhao blurIcon" name="tabs" :tabindex="tabindexNumChange()"></i>
            </el-tooltip>
            <el-input v-model.trim="tableData.intent" :minlength="2" :maxlength="50"
                      placeholder="请输入调用名称" @input.native="changeRoute"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div id="oftenInfo">
      <p class="title">
        常用表达
        <el-tooltip placement="top">
          <div slot="content">用户使用场景中常用的表达方式. 如查询天气,<br/>帮我查一下今天的天气, 查一下上海明天的天气, 查一下天气等</div>
          <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
        </el-tooltip>
      </p>
      <div class="intentionContainer" style="padding-bottom:20px;">
        <el-input id="input3" placeholder="回车添加常用表达" v-model.trim="addVal" @keyup.enter.native="addExpressions" @input.native="changeRoute"></el-input>
        <el-button type="primary" round @click="addExpressions" :disabled="addExpFlag">添加</el-button>
        <div style="padding:0 30px">
          <ul class="form-group oftenInfo_table" style="margin-top:10px;">
            <li class="list-group-item" v-for="(val, index) in page">
              <div class="oftenInfo_title">
                <span @mousedown="getClient($event)" v-html="Expression(val)" @mouseup="getSel($event, val)">
                </span>
                <i class="el-icon-circle-close deleteIcon pull-right" @click="removeExp(index)"
                   style="margin-top:12px;"></i>
              </div>
              <el-collapse-transition>
                <table class="table text-center" v-if="val.entities.length" v-show="val.show">
                  <thead>
                  <tr>
                    <th class="text-center">槽位标识</th>
                    <!--<th class="text-center">中文名称</th>-->
                    <th class="text-center">对应字典</th>
                    <th class="text-center">值</th>
                    <th class="text-center">操作</th>
                  </tr>
                  </thead>
                  <tbody class="center-tbody">
                  <tr v-for="(item, n) in val.entities">
                    <td>
                      {{item.entity}}
                      <!--<input type="text" class="input_text" placeholder="请输入槽位标识" v-model="item.entity">-->
                    </td>
                    <!--<td>-->
                    <!--&lt;!&ndash;{{item.chinese_name}}&ndash;&gt;-->
                    <!--<input type="text" class="input_text" placeholder="请输入中文名称" v-model="item.chinese_name">-->
                    <!--</td>-->
                    <td>
                      <!--@click="searchDect($event, item)"-->
                      {{item.dict}}
                      <!--<input type="text" class="input_text" v-model="item.dict">-->
                    </td>
                    <td>
                      {{item.value}}
                      <!--<input type="text" class="input_text" v-model="item.value">-->
                    </td>
                    <td>
                      <i class="el-icon-circle-close deleteIcon" @click="removeEnt(index, n)"></i>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </el-collapse-transition>
            </li>
          </ul>
          <div class="block" style="float:right" v-if="tableData.expressions.length">
            <el-pagination
              :page-size="5"
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :total="tableData.expressions.length">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div id="add_slots">
      <p class="title">
        槽位列表
        <el-tooltip content="描述意图的数据(键值对的集合),也是实现意图所需要的参数" placement="top">
          <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
        </el-tooltip>
      </p>
      <div class="intentionContainer">
        <div style="padding:20px 30px 30px">
          <table class="table text-center">
            <thead>
            <tr>
              <th class="text-center">
                槽位标识
                <el-tooltip  content="定义槽位的标识名称，2~50字符，支持英文数字下划线。从值中添加的参数，槽位将自动添加" placement="top">
                  <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                </el-tooltip>
              </th>
              <!--<th class="text-center">中文名称</th>-->
              <th class="text-center">选择词典
                <el-tooltip content="可选择自定义词典及系统词典，平台将根据开发者添加的词典从用户表达中抽取槽位" placement="top">
                  <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                </el-tooltip>
              </th>
              <th class="text-center">值
                <el-tooltip content="启用多轮对话后，开发者可以从值中添加前置意图的槽位参数" placement="top">
                  <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                </el-tooltip>
              </th>
              <th class="text-center">追问语句
                <!--<el-tooltip :popper-class="toolTipClass" content="1" placement="top">
                  <i class="icon iconfont icon-wenhao blurIcon"></i>
                </el-tooltip>-->
              </th>
              <th class="text-center" width="10%">是否必填</th>
              <th class="text-center">操作</th>
            </tr>
            </thead>
            <tbody class="center-tbody">
            <tr>
              <td>
                <!--<input type="text" readonly class="input_text" v-model="addSlo.entity">-->
                <input type="text" :readonly="checkRepeat(addSlo.entity)" class="input_text input-read" placeholder="请输入槽位标识"
                       v-model.trim="addSlo.entity"></td>
              <!--<td> <input type="text" class="input_text" placeholder="请输入中文名称" v-model="addSlo.chinese_name"></td>-->
              <td @click="searchDect($event, addSlo)" >
                <span v-if="addSlo.dict == ''" style="color:#409EFF;cursor: pointer;">请选择词典</span>
                <span v-else style="background: rgba(236,131,128,.5)">{{ addSlo.dict.indexOf('@') == -1 ?'@' + addSlo.dict: addSlo.dict  }}</span>
              </td>
              <td @click.prevent.stop="searchValue($event)" style="color:#409EFF;cursor: pointer;" :readonly="checkRepeat(addSlo.entity)">
                <span v-if="addSlo.value == ''">请选择值</span>
                <span v-else>{{ addSlo.value }}</span>
              </td>
              <td @click="additionalF(addSlo)" v-html="checkAdd(addSlo)" style="color: #409EFF;cursor: pointer;">
                <!--{{}}-->
              </td>
              <td>
                <el-switch
                  v-model="addSlo.required"
                  active-color="#409EFF"
                  inactive-color="#dcdcdc">
                </el-switch>
              </td>
              <td>
                <!--<a href="javascript:;" @click="addSlots" class="addSlots">添加槽位</a>-->
                <el-button type="text" size="small" @click="addSlots" class="addSlots">添加槽位</el-button>
              </td>
            </tr>
            <!--拖拽-->
            <tr v-for="(item, n) in entitiesList">
              <td>
                {{item.entity}}
                <!--<input type="text" class="input_text" v-model="item.entity">-->
              </td>
              <!--<td>-->
              <!--<input type="text" class="input_text" placeholder="请输入中文名称" v-model="item.chinese_name">-->
              <!--</td>-->
              <td>
                <!--@click="searchDect($event, item)"-->
               <span style="background: rgba(236, 131, 128, 0.5);">{{item.dict.indexOf('@') == -1 ?  item.dict ? '@'+item.dict : '' : item.dict}}</span>
              </td>
              <td>
                <!--${{item.dict}}-->
                {{item.value.indexOf('$') != -1 ? item.value : item.dict ?  '$'+item.dict : ''}}
              </td>
              <td v-html="checkAdd2(item)" style="color: #409EFF;cursor: pointer;" @click="additionalF(item)">
                <!---->
                <!--{{checkAdd(item)}}-->
                <!--{{item.ask_query ? item.ask_query.join(',') : item.required ? '添加' : '&#45;&#45;'}}-->
              </td>
              <td>
                <el-switch
                  v-model="item.required"
                  active-color="#409EFF"
                  inactive-color="#dcdcdc">
                </el-switch>
              </td>
              <td>
                <i class="el-icon-circle-close deleteIcon" @click="removeEntList(n, item)"></i>
              </td>
            </tr>
            <!--<tr>-->
              <!--<td colspan="6" class="text-left">-->
                <!--<a href="javascript:;" @click="addSlots" class="addSlots">添加槽位</a>-->
              <!--</td>-->
            <!--</tr>-->
            </tbody>
          </table>
          <el-dialog
            class="addItional"
            title="添加追问语句"
            :visible.sync="additionalVisible"
            width="30%"
          >
            <div style="width: 100%;overflow: hidden;padding-left: 10px">
              <el-input v-model.trim="additional" placeholder="回车添加追问语句" @keyup.enter.native="addItional" style="width: calc(100% - 100px);"></el-input><el-button type="primary" @click="addItional" style="border-radius: 20px">添加</el-button>
            </div>
            <ul style="width: 100%;">
              <li v-for="(val, n) in additionalList" style="text-align: left;padding: 0 10px 0 10px;">
                <span>{{val}}</span>
                <i class="el-icon-circle-close deleteIcon pull-right" @click="removeItional(n)"></i>
              </li>
            </ul>
            <span slot="footer" class="dialog-footer">
                  <el-button type="primary" round @click="determine">保 存</el-button>
                 <el-button round @click="additionalVisible = false">关闭</el-button>
  </span>
          </el-dialog>
        </div>
      </div>
    </div>
    <div id="intention_confirm">
      <p class="title">
        意图确认
        <el-tooltip content="当为所有槽位填满后,系统自动向用户发起一次问询进行二次意图确认" placement="top">
          <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
        </el-tooltip>
      </p>
      <div class="intentionContainer">
        <div class="intent_container" style="padding:10px 30px 20px;clear:both;overflow:hidden">
          <div class="add_intent_list">
            <el-button type="primary" round @click="(dialogVisible = true, intentV = '')">添加意图确认话术</el-button>
          </div>
          <div class="list_intent">
              <span class="intention_list" v-for="(intentCon, n) in tableData.intent_confirm">{{intentCon}}
            <i class="el-icon-circle-close deleteIcon" @click="removeintentConfirm(n)"></i></span>
          </div>
        </div>
        <el-dialog
          class="itentconfirm"
          title="意图确认话术"
          :visible.sync="dialogVisible"
          width="30%"
        >
          <el-input v-model.trim="intentV" @keyup.enter.native="intentConfirm" placeholder="例：您确定要定明早$time的闹钟吗?" @input.native="slots_quote(intentV)"></el-input>
          <transition name="fade">
          <el-card class="box-card" v-show="slotsFlag" id="boxCard">
              <div :key="-1" class="text item" v-show="entitiesList.length == 0" @click="slotsFlag = false">
                暂无槽位信息
              </div>
            <div v-for="(item, index) in entitiesList" :key="index" class="text item" @click="add_quote(intentV, item.entity)">
              {{item.entity}}
            </div>
          </el-card>
          </transition>
          <span slot="footer" class="dialog-footer">
    <el-button type="primary" round @click="intentConfirm">添 加</el-button>
               <el-button round @click="dialogVisible = false">关闭</el-button>
  </span>
        </el-dialog>
      </div>
    </div>
    <div id="dialogue">
      <p class="title">
        多轮对话（选填）<el-tooltip content="基于上下文的多轮对话, 可以通过该功能调用上次意图的值" placement="top">
          <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
        </el-tooltip>
        <template>
          <el-switch
            v-model="dialogueShow"
            active-color="#409EFF"
            inactive-color="#dcdcdc">
          </el-switch>
        </template>
      </p>
      <div class="intentionContainer">
        <div style="padding:0 30px">
          <template>
            <div>
              <div style="margin-top: 20px">
                <el-collapse-transition>
                  <div v-if="dialogueShow">
                    <div class="info">
                      <div style="min-height: 30px">
                        <template>
                          <table style="margin-bottom: -1px;border: 1px solid #ebeef5;border-bottom:none;" class="table text-center">
                            <thead>
                            <tr>
                              <th style="width: 25%;" class="text-center">
                                前置意图
                                <el-tooltip placement="top">
                                  <div slot="content">开发者可以为每个意图设置一个或多个前置意图，<br/>以此进行参数传递，添加前置意图后，可在槽位列表-值中进行引用</div>
                                  <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                                </el-tooltip>
                              </th>
                              <th style="width: 25%;" class="text-center">
                                保存轮次
                                <el-tooltip content="在多轮对话语境中，能够被识别为前置意图最大的轮次。设置为0，则不会识别前置意图" placement="top">
                                  <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                                </el-tooltip>
                              </th>
                              <th style="width: 25%;" class="text-center">
                                输出前置意图
                                <el-tooltip placement="top">
                                  <div slot="content">如果开发者选择打开“输出前置意图”开关，那么在输出intent<br/>时，将输出前置意图的intent<br/>意图内的连续对话场景往往需要打开”输出前置意图“开关<br/>跨意图的连续对话场景往往需要关闭”输出前置意图“开关，即<br/>默认输出当前意图<br/>详情查看重要概念释义文档</div>
                                  <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
                                </el-tooltip>
                              </th>
                              <th style="width: 25%;" class="text-center">操作</th>
                            </tr>
                            </thead>
                          </table>
                          <el-table
                            id="info-more"
                            :show-header=false
                            :data="tableData.multi_conversation"
                            style="width: 100%;"
                          >
                            <el-table-column
                              align="center"
                              style="width: 25%;"
                            >
                              <template slot-scope="scope">
                                <template>
                                  <el-select class="dis" v-model="tableData.multi_conversation[scope.$index].prepositive_intent"
                                             @click.native="aaa(tableData.multi_conversation[scope.$index].prepositive_intent)"
                                             placeholder="请选择">
                                    <el-option
                                      v-for="(item,index) in prepositive_intent"
                                      :key="index"
                                      :label="item.chinese_name"
                                      :value="item.intent"
                                      @click.native="check_prepositive_intent($event,tableData.multi_conversation[scope.$index].prepositive_intent)"
                                    :disabled="checkIntent.indexOf(item.intent) != -1"
                                    >

                                    </el-option>
                                  </el-select>
                                </template>
                              </template>
                            </el-table-column>
                            <el-table-column
                              align="center"
                              style="width: 25%;"
                            >
                              <template slot-scope="scope">
                                  <span class="countBox">
                                    <i class="el-icon-minus count countLeft" @click="reduceCount(scope.row)"></i>
                                    <el-input style="text-align: center" type="tel" :id="'step' + scope.$index"
                                              v-model="scope.row.max_inherited_distance"
                                              @blur="handleChange(scope.row)"></el-input>
                                    <i class="el-icon-plus count countRight" @click="addCount(scope.row)"></i>
                                  </span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              align="center"
                              style="width: 25%;"
                            >
                              <template slot-scope="scope">
                                <template>
                                  <el-switch
                                    v-model="scope.row.output_intent"
                                    active-color="#409EFF"
                                    inactive-color="#dcdcdc">
                                  </el-switch>
                                </template>
                              </template>

                            </el-table-column>
                            <el-table-column
                              align="center"
                              style="width: 25%;"
                            >
                              <template slot-scope="scope">
                                <i class="el-icon-circle-close deleteIcon heightcolumn"
                                   @click="deleteDialogue(scope.$index)"></i>
                              </template>
                            </el-table-column>
                          </el-table>
                          <p class="add-p"><a href="javascript:;" @click="add_multi">添加</a></p>
                        </template>

                      </div>
                    </div>
                  </div>
                </el-collapse-transition>
              </div>
            </div>
          </template>
        </div>
      </div>

    </div>
    <div style="text-align: center">
      <el-button class="intentSavebtn" type="primary" round id="Preservation" :loading="saveStatus" @click="addIntents">
        保存
      </el-button>
    </div>

    <div class="searchDic" :style="{'left': seaDicL -220+'px', 'top': seaDicT +50+'px'}" v-show="dicShow">
      <input placeholder="快速搜索" class="el-input__inner" @input.stop="searchDicList" v-model="dict"
             @click.stop.prevent=""/>
      <ul>
        <li v-if="dicList.length == 0" @click="dicShow = false">暂无引用词典</li>
        <li v-for="dic in dicList" @click="getDicVal(dic.dict_name, dic)">{{dic.dict_name}}</li>
      </ul>
    </div>
    <div class="searchValue" :style="{'left': seaDicL -220+'px', 'top': seaDicT +50+'px'}" v-show="valueShow">
      <ul id="valueSlots">
        <li v-if="options.length == 0" @click="valueShow = false">暂无引用槽位</li>
        <li v-for="(value, key) in options">
          <div> {{key}}</div>
          <ol>
            <li v-for="val in options[key]" @click.prevent.stop="changeSlotinfo(key, val)">{{val}}</li>
          </ol>

        </li>
      </ul>
      <!--<div class="block" id="valueSlot">-->
      <!--&lt;!&ndash;<span class="demonstration">默认 click 触发子菜单</span>&ndash;&gt;-->
      <!--<el-cascader-->
      <!--:options="options"-->
      <!--v-model="selectedOptions"-->
      <!--@change="handleChange">-->
      <!--</el-cascader>-->
      <!--</div>-->
    </div>
    <div id="forthwithTest">
      <div class="testSmall" @click.stop.prevent="testWhole">
        <div class="tes_c">
          <span class="testTxt">即时测试</span>
          <img src="../../../../static/images/skill/icon1.png" alt="">
        </div>

      </div>
      <div class="testWhole" @click.stop.prevent="">
        <audio :src="audio_url" autoplay id="audio"></audio>
          <p class="whole_test">即时测试</p>
        <div class="whole_height">
          <div class="whole_query">
            <input type="text" v-model="query" @keyup.enter="test" placeholder="输入常用表达">
            <img :src="mic_change" alt="麦克风" class="Microphone" @mousedown="micDown" @mouseup="micUp" @mouseout="micUp">
          </div>
          <div class="whole_con" v-loading="mediaLoading">
            <div class="whole_con1">
              <p>输入语音内容</p>
              <div>{{queries.query}}</div>
            </div>
            <div class="whole_con1">
              <p>输出语音回复</p>
              <div>{{queries.intent == 'other'? '意图无法识别' : queries.skill_response.response.outSpeech.text ? queries.skill_response.response.outSpeech.text : '意图识别已完成'}}</div>
            </div>
            <div class="whole_con1">
              <p>意图识别结果</p>
              <div>{{queries.intent}}</div>
            </div>
            <div class="whole_con1">
              <p>槽位识别结果</p>
              <pre style="border:none">{{queries.slots.length == 0 ? '' : queries.slots}}</pre>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import qs from 'qs'
  import { mediaStart,mediaStop } from './work'
  import {
    searchDictApi,
    addExpApi,
    getUserId,
    addIntentsApi,
    searchAllDictApi,
    getIntentsApi,
    needIntentApi,
    getPrepositiveApi,
    postSysDictRef,
    delSysDictRef,
    refSysIntApi,
    testApi,
    ttsApi
  } from '@/api'

  export default {
    data() {
      let check_intent = (rule, value, callback) => {
        setTimeout(() => {
          var reg = new RegExp("^[a-zA-Z0-9_]+$");
          if (!reg.test(value)) {
            callback(new Error('仅支持数字，字母，下划线'));
          } else {
            callback();
          }
        }, 100);
      }
      let check_chinese_name = (rule, value, callback) => {
        setTimeout(() => {
          var reg = new RegExp("^[\u4e00-\u9fa5]+$");
          if (!reg.test(value)) {
            callback(new Error('仅中文2~50汉字'));
          } else {
            callback();
          }
        }, 100);
      }
      return {
        addSlo: { // 添加的槽位信息
          start: -1,
          end: -1,
          value: '',
          entity: '',
          chinese_name: '',
          dict: '',
          dict_id: '',
          required: false,
          ask_query: []
        },
        skill_id: null,
        online_num:'',
        dicList: [],
        dicShow: false,
        valueShow: false,// 用来显示前置意图槽位信息
        dicItem: {},
        dict: '',//输入字典名字
        seaDicL: '',
        seaDicT: '',
        entitiesList: [],
        activeName: '1',
        intentV: '',
        dialogVisible: false,
        additionalVisible: false,
        additional: '',//追问语句
        additionalList: [],//追问语句列表
        itemDict: '',
        additionalItem: {},
        addVal: '',
        value2: true,
        dev_id: null,
        valText: '',
        text: '',
        c_page: '',
        page: [],
        tableData: {
          skill_id: null,
          intent_confirm: [],
          intent: '',
          chinese_name: '',
          expressions: [
//                  {
//                    text: '我想听刘德华的冰雨',
//                    show: false,
//                    entities: [
//                      {
//                        start: '3',
//                        end: '6',
//                        value: '刘德华',
//                        entity: 'singer',
//                        dict: 'sys.singer',
//                        required: false,
//                        ask_query: []
//                      }
//                    ]
//                  }
          ],
          multi_conversation: [
            {
              prepositive_intent: '',
              max_inherited_distance: 5,
              output_intent: false
            },
          ]
        },
        rules: {
          chinese_name: [
            {required: true, message: '请输入意图中文名', trigger: 'blur'},
            {min: 2, max: 50, message: '长度在 2 到 50 个汉字', trigger: 'blur'},
            {validator: check_chinese_name, trigger: 'blur'}
          ],
          intent: [
            {required: true, message: '请输入意图识别名', trigger: 'blur'},
            {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'},
            {validator: check_intent, trigger: 'blur'}
          ],
        },
        saveStatus: false,
        dialogueShow: false,
        dialogueData: [],
        prepositive_intent: [],// 所有前置意图列表
        value: '选择前置意图',
        options: [
//          {
//            value: 'zhinan',
//            label: '指南',
//            children: [{
//              value: 'wsss',
//              label: '忘记'
//            }]
//          },
//          {
//            value: 'zhinan',
//            label: '指南2',
//            children: [{
//              value: 'wsss',
//              label: '忘记'
//            },
//              {
//                value: 'wsss',
//                label: '方法'
//              },
//              {
//                value: 'wsss',
//                label: '钉钉'
//              }]
//          }
        ],
        selectedOptions: [],
        aa: [],
        slotsFlag: false,
        checkIntent: [],
        tabindexNum:"-1",
        query: '',
        queries: {
          query: '',
          slots: '',
          intent: '',
          skill_response: {
              response: {
                  outSpeech: {
                      text: ''
                  }
              }
          }
          // answer: {text: ' '}
        },
        audio_url: '',
        addExpFlag: false, //添加常用表达式开关,
        mic_change: '../../../../static/images/skill/Microphone.png',
        mediaLoading:false,
        micDownFlag: true
      }
    },
    filters: {},
    watch: {
      'additionalVisible': function () {
        !this.additionalVisible ? this.additional = '' : null
      }
    },
    created() {
      this.skill_id = this.$route.query.skillId
      this.getUserId()
      this.intents()
      this.getPrepositive()
      this.tabindexNumChange()
    },
    computed: {


    },
    methods: {
      micDown () {
        this.micDownFlag = false //判断是否为录音状态
          this.mic_change = '../../../../static/images/skill/Microphone2.png';
          if(mediaStart() == 'no'){
            this.$message.warning('您的设备不支持录音')
//            alert('您的设备不支持录音')
            return false;
          }else{
            mediaStart();
          }
      },
      micUp () {
        if (this.micDownFlag) return
        this.mediaLoading = true
        this.micDownFlag = true
        this.mic_change = '../../../../static/images/skill/Microphone.png';
        var _this = this;
        var arr = mediaStop().slice(44,-1);
        function randomPid(randomFlag, min, max) {
          var str = "",
            range = min,
            arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

          // 随机产生
          if (randomFlag) {
            range = Math.round(Math.random() * (max - min)) + min;
          }
          for (var i = 0; i < range; i++) {
            var pos = Math.round(Math.random() * (arr.length - 1));
            str += arr[pos];
          }
          return str;
        }

        // 初始化一个 WebSocket 对象
          var ws = null
          if (window.location.host.includes('opentw.ainirobot.com')) {
              ws = new WebSocket("wss://jp-asrwss.ainirobot.com:443/ws/streaming-asr");
          } else {
              ws = new WebSocket("wss://asrwss.ainirobot.com:443/ws/streaming-asr");
          }


          // 建立 web socket 连接成功触发事件
        ws.onopen = function () {
          //console.log("连接ASR服务器成功");
          //发送数据
            var pkgnum = 2;
            var sid = "ws_asr_" + randomPid(false, 32);
            var pid = '7001';
            var app_name = 'com.cm.speech.asr';
            var firstPkg = "{\"sid\":\"" + sid + "\",\"pid\":\"" + pid + "\",\"app\":\"" + app_name + "\",\"devid\":\"test-20171009001\",\"token\":\"\",\"type\":\"0\"}"; //app为微信端新分配，可以再协商
            if (window.location.host.includes('opentw.ainirobot.com')) {
                //首包
                 sid = "ws_asr_tw_" + randomPid(false, 32);
                 pid = '61';
                 app_name = 'com.cm.speech.asr';
                 firstPkg = "{\"sid\":\"" + sid + "\",\"pid\":\"" + pid + "\",\"app\":\"" + app_name + "\",\"devid\":\"test-20171009001\",\"token\":\"\",\"type\":\"0\"}"; //app为微信端新分配，可以再协商

            }
          //console.log("first-pkg:" + firstPkg);
          ws.send(firstPkg) //发第一个包

          //console.log('ws握手成功，可以开始发送数据流');


          var dataPkg = parseInt(arr.size);

          var len = 1600; //语音包暂定1024，可以根据实际情况修改
          var blocks = parseInt(dataPkg / len);
          var lastPkg = parseInt(dataPkg % len);
          if (lastPkg > 0) blocks += 1;
          pkgnum += blocks;

          var startpos = 0;
          var endpos = len - startpos;

          for (var i = 1; i <= blocks; i++) {
            //数据分包
            if (i == blocks && lastPkg > 0) {
              len = lastPkg;
            }
            //console.log("data size:" + arr.size + " spos:" + startpos + " epos:" + endpos);
            var slice_data = arr.slice(startpos, endpos);
            //console.log("send data num:" + i + " slen:" + slice_data.size);
            ws.send(slice_data);
            startpos += len;
            endpos += len;
//                  console.log(slice_data)
//            console.log(pkgnum);
            //console.log(startpos, endpos)
          }

          var endPkg = "{\"pkgnum\":" + pkgnum + "}";
          ws.send(endPkg);//发最后一个包


        };
        // 接收服务端数据时触发事件
        ws.onmessage = function (evt) {
          var received_msg = JSON.parse(evt.data);
          //console.log("数据已接收...");
          if(received_msg.end_flag == 1){
            //console.log(received_msg.result.nbest[0]);
            _this.query = received_msg.result.nbest[0];
            _this.test();
          } else if (received_msg.errno) {
            _this.mediaLoading = false;
          }
        };

        //断开 web socket 连接成功触发事件
        ws.onclose = function () {
          //console.log("连接已关闭...");
        };

      },
      changeRoute () {
        this.$store.dispatch('changeR',false);
      },
      async test () {
        if (this.query == '') {
          this.$message.error('输入语句不能为空')
          return
        }
        let params = {
          "query":this.query,
          "user_semantics": JSON.stringify({"deviceid": "open_"+this.dev_id, "skill_id": this.skill_id})
        }
       let res = await testApi(params)
        if (res.data.code == 200) {
          this.query = ''
          if (res.data.data[0]) {
            let text = ''
            res.data.data[0].intent == 'other'? text = '意图无法识别' : (res.data.data[0].skill_response.response.outSpeech.text ? text = res.data.data[0].skill_response.response.outSpeech.text : text = '意图识别已完成')
            this.tts(text)
          }
          this.queries = res.data.data[0]
          this.mediaLoading = false;
        } else {
          this.mediaLoading = false;
        }
      },
      async tts (audio) {
        let res = await ttsApi(qs.stringify({text: audio}))
        if (res.data.code == 200) {
          this.audio_url = res.data.data.resource_url
        }
      },
      testWhole () {
          $('.testWhole').animate({'left': -215+'px'},400)
      },
      aaa(oldIntent) {
        this.checkIntent = this.checkIntent.filter(item => {
          return item != oldIntent
        })

      },
      check_prepositive_intent: function (event, intent){
        this.checkIntent.push(intent)
      },
      //自定义表头
      renderHeader1(){
        return(
          <div>
            前置意图
            <el-tooltip placement="top">
              <div slot="content">开发者可以为每个意图设置一个或多个前置意图，<br/>以此进行参数传递，添加前置意图后，可在槽位列表-值中进行引用</div>
              <i class="icon iconfont icon-wenhao blurIcon"></i>
            </el-tooltip>
          </div>
        )
      },
      renderHeader2(){
        return(
          <div>
          保存轮次
          <el-tooltip content="在多轮对话语境中，能够被识别为前置意图最大的轮次。设置为0，则不会识别前置意图" placement="top">
          <i class="icon iconfont icon-wenhao blurIcon"></i>
          </el-tooltip>
          </div>
        )
      },
      renderHeader3(){
        return(
          <div>
          输出前置意图
          <el-tooltip placement="top">
            <div slot="content">如果开发者选择打开“输出前置意图”开关，那么在输出intent<br/>时，将输出前置意图的intent<br/>意图内的连续对话场景往往需要打开”输出前置意图“开关<br/>跨意图的连续对话场景往往需要关闭”输出前置意图“开关，即<br/>默认输出当前意图<br/>详情查看重要概念释义文档</div>
          <i class="icon iconfont icon-wenhao blurIcon"></i>
          </el-tooltip>
          </div>
        )
      },
      // 意图确认话术槽位引用
      slots_quote (query) {
        if (query == '') {
          this.slotsFlag = false
          return
        }
        if (query.lastIndexOf('$') == query.length-1) {
          this.slotsFlag = true
        }
      },
      // 追加槽位（$槽位）
      add_quote(intentV, entity) {
        this.intentV = intentV + entity
        this.slotsFlag = false
  },

      checkAdd(addSlo) { // 展示追问语句形式-- 添加，添加（2）
        if (addSlo.ask_query && addSlo.ask_query.length != 0) {
          return `已添加[${addSlo.ask_query.length}]`
//          return addSlo.ask_query.join(',')
        } else {
          if (!addSlo.required) {
            return '--'
          } else {
            return `添加`
          }
        }
      },
      checkAdd2(addSlo) { // 展示追问语句形式-- 添加，添加（2）
        if (addSlo.ask_query && addSlo.ask_query.length != 0) {
          return `已添加[${addSlo.ask_query.length}]`
//          return addSlo.ask_query.join(',')
        } else {
          if (!addSlo.required) {
            return '--'
          } else {
            return `添加`
          }
        }
      },
      Expression(val) { // 处理表达式槽位变色问题
        let text = val.text
        let str = ''
        let arrlist = []
        let text2 = text.split('')
        val.entities.forEach((item, index) => {
          for (var j = item.start; j < item.end; j++) {
            arrlist.push(j)
          }
        })
        text2.forEach(function (item, index) {
          if (arrlist.indexOf(index) == -1) {
            str += '<span>' + item + '</span>'
          } else {
            str += '<span style="background:rgba(236,131,128,.5);">' + item + '</span>'
          }
        })
//        val.entities.forEach((item, index) => {
//          if (index == 0) {
//            text = val.text.replace(eval('/'+item.value+'/'), '<span style="background:rgba(236,131,128,.5);">$&</span>')
//          } else {
//            text = text.replace(eval('/'+item.value+'/'), '<span style="background:rgba(200,131,128,.5);">$&</span>')
//          }
//        })
        return str
      },
      getClient(e) { //记录鼠标点击时x
        this.x = e.clientX
      },
      getSel(e, val) { // 判断是选中文字还是click
        this.aa = val
        this.valText = val.text
        if (e.clientX != this.x) {
//          let text
          this.text = document.getSelection().toString()
          this.searchDect(e, val)
        } else {
          this.$set(val, 'show', !val.show)
        }
      },
      async getUserId() {//获取用户id skillId
        let res = await getUserId()
        this.dev_id = res.data.data.id
//            this.$route.query.skillId ? void(0) : this.$router.push('/skillList')
        this.tableData.skill_id = this.$route.query.skillId
        this.online_num = this.$route.query.online
        //console.log(this.online_num)
      },
      async intentConfirm() {
        this.dialogVisible = false
        if (this.intentV.length < 2 || this.intentV.length > 50) {
          this.$message.error('意图确认话术仅支持2~50字符')
          return
        }
        if (this.intentV) {
          this.tableData.intent_confirm.push(this.intentV)
          if (this.tableData.intent_confirm.length == 1) {
            let res = await refSysIntApi(qs.stringify({skill_id: this.skill_id, intents: ['PrWFTG27xCSe9C5JkzG6S6']}))
            if (res.data.code == 200) {
              refSysIntApi(qs.stringify({skill_id: this.skill_id, intents: ['kHvsPxfkzGfky44Ux6YefK']}))
            }
          }
          this.intentV = ''
        }
      },
      removeintentConfirm(n) {
        this.tableData.intent_confirm.splice(n, 1)
      },
      slotsReplace(List) {// 槽位去重
        let hash = {}
        let arr = []
        List.forEach((item, index) => {
          if (hash[item.entity]) {

          } else {
            hash[item.entity] = true
            arr.push(item)
          }
        })
        this.entitiesList = arr
      },
      async addExpressions() {//添加常用表达
        if (this.addVal) {
          this.addExpFlag = true
          let res = await addExpApi(this.$route.query.skillId, qs.stringify({'query': this.addVal}))
          if (res.data.code != 200) {
            this.addExpFlag = false
            return this.$message({message: '添加常用表达失败', type: 'error'})
          }
          this.addExpFlag = false
          this.tableData.expressions.unshift(
            {text: res.data.data.text, entities: res.data.data.entities})
          this.addVal = ''
          let entities2 = JSON.parse(JSON.stringify(res.data.data.entities))
//          entities2.forEach(item => {
//            item.value = '$' + item.dict
//          })
          this.entitiesList = JSON.parse(JSON.stringify(this.entitiesList.concat(entities2)))
//          console.log(this.entitiesList)
//          this.slotsReplace(this.entitiesList) //槽位去重
          this.handleCurrentChange(1) // 分页
          this.slotsReplace(this.entitiesList) //去重
        }
      },
      // 获取词典列表
      async searchDect(e, item) {
        this.dicItem = item
        this.seaDicL = e.pageX
        this.seaDicT = e.pageY
        if (e.target.tagName == 'SPAN') {
          let res = await searchAllDictApi(this.tableData.skill_id)
          this.dicShow = true
          if (res.data.code == 200) {
            this.dicList2 = res.data.data
            this.dicList = res.data.data
          }
        } else {
          let res = await searchDictApi(this.tableData.skill_id)
          this.dicItem = item
          this.dicShow = true
          if (res.data.code == 200) {
            this.dicList2 = res.data.data
            this.dicList = res.data.data
          }
        }
      },
      //点击对应字典替换原始字典
      getDicVal(dicVal, dic) {
        let params = {
          "specified_sys_dicts": [
            dic.dict_id
          ]
        }
        postSysDictRef(this.$route.query.skillId,params).then((res)=>{
//          console.log(res)
        },(err)=>{
          console.log(err)
        })
        if (this.dicItem.entities || this.dicItem.entities == []) {
          if (!this.text) return
          let start = this.valText.indexOf(this.text)
          let end = start + this.text.length
          let enFlag = true //判断表达式下有没有相同值得槽位
          let listFlag = true //判断槽位列表有没有相同标识
          let valInfo = {
            start: start,
            end: end,
            value: this.text,
            entity: dicVal,
            dict: dicVal,
            dict_id: dic.dict_id,
            required: false,
            ask_query: []
          }
          for (let i = 0; i < this.dicItem.entities.length; i++) {
            let item = this.dicItem.entities[i];
            if (item.value == this.text) {
              enFlag = false
              // 表达式添加槽位信息
              this.dicItem.entities[i] = valInfo
            }
          }
          if (enFlag) {
            this.dicItem.entities.push(valInfo)
          }
          this.entitiesList.forEach((item, index) => {
            if (item.entity == dicVal) {
              listFlag = false
              // 槽位总列表替换
              this.entitiesList[index] = valInfo
            }
          })
          if (listFlag) {
            this.entitiesList.push(valInfo)
          }
          //            this.entitiesList.push({
//              start: start,
//              end: end,
//              value: this.text,
//              entity: dicVal,
//              dict: dicVal,
//              required: false,
//              ask_query: []
//            })
//          this.entitiesList.forEach(item => {
//            console.log(item.value);
//            console.log(this.text);
//            if (item.value == this.text) {
//              console.log(item,9);
//              item = {
//              start: start,
//              end: end,
//              value: this.text,
//              entity: dicVal,
//              dict: dicVal,
//              required: false,
//              ask_query: []
//            }
//            }
//          })
//          this.dicItem.entities.push({ // 表达式添加槽位信息
//              start: start,
//              end: end,
//              value: this.text,
//              entity: dicVal,
//              dict: dicVal,
//              required: false,
//              ask_query: []
//            })
//            this.entitiesList.push({
//              start: start,
//              end: end,
//              value: this.text,
//              entity: dicVal,
//              dict: dicVal,
//              required: false,
//              ask_query: []
//            })
          this.dicShow = false
          this.slotsReplace(this.entitiesList)
          this.text = ''
          this.valText = ''
        } else {
          this.dicItem.dict = dicVal
          this.dicItem.dict_id = dic.dict_id
          this.dicShow = false
          this.dict = ''
        }
      },
      //输入字典查找
      searchDicList() {
        this.dicList = this.dicList2.filter(dic => {
//          console.log(dic.dict_name);
//          console.log(this.dict);
          return dic.dict_name.indexOf(this.dict) != -1
        })

      },
      //删除表达式详细
      removeEnt(index, n) {
//        console.log(index,n)
        this.$confirm('确定删除表达式下的这个槽位吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let num = 0
          this.tableData.expressions.forEach(item => {
            item.entities.forEach(val => {
              if (val.entity == this.tableData.expressions[index]['entities'][n].entity) {
                num ++
              }
            })
          })

          if (num == 1) {
            this.entitiesList.forEach((item, i) => {
              if (item.entity == this.tableData.expressions[index]['entities'][n].entity) {
                this.entitiesList.splice(i, 1)
              }
                })
          }

          this.tableData.expressions[index]['entities'].splice(n, 1)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        }).catch(() => {
//          console.log(0);
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      //删除槽位
      removeEntList(n, value) {
        this.$confirm('此操作将删除所有常用表达中的相同槽位', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.entitiesList.splice(n, 1)
          this.tableData.expressions.forEach(item => {
            item.entities = item.entities.filter((val, index) => {
              return val.entity != value.entity
            })
          })
          // 删除引用得词典
          if (value.dict_id) {
            let params = {
              "delete_sys_dicts": [
                value.dict_id
              ]
            }
            delSysDictRef(this.$route.query.skillId,params).then((res)=>{
//              console.log(res)
            },(err)=>{
              console.log(err)
            })
          }
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      //删除表达式
      removeExp(index) {
        this.$confirm('是否删除此表达式?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData.expressions[index]['entities'].forEach((item, i) => {
            let num = 0
            this.tableData.expressions.forEach(item => {
              item.entities.forEach(val => {
                if (val.entity == this.tableData.expressions[index]['entities'][i].entity) {
                  num ++
                }
              })
            })
            if (num == 1) {
              this.entitiesList.forEach((item, n) => {
                if (item.entity == this.tableData.expressions[index]['entities'][i].entity) {
                  this.entitiesList.splice(n, 1)
                }
              })
            }
          })
          this.tableData.expressions.splice(index, 1)
          this.page.splice(index, 1)
            if (!this.page.length) {
                this.handleCurrentChange(this.c_page - 1)
            } else {
                this.handleCurrentChange(this.c_page)
            }
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      //添加槽位
      addSlots() {
        if (this.addSlo.entity == '') {
          this.$message.error('槽位标识不能为空')
          return
        }
        let reg = /[^0-9A-Za-z_.-]/g
        if (reg.test(this.addSlo.entity)) {
          this.$message.error('槽位标识只能是数字、字母、下划线、点')
          return
        }
//        console.log(this.entitiesList.length);
        for (let i = 0; i < this.entitiesList.length; i++) {
          let item = this.entitiesList[i]
          if (item.entity == this.addSlo.entity) {
            this.$message.error('槽位标识不能重复')
            this.addSlo.entity = ''
            this.addSlo.value = ''
            return

          }
        }
//        if (this.addSlo.entity == '') {
//          this.$message.error('槽位标识不能为空')
//        }
        this.entitiesList.unshift(this.addSlo)
        this.tableData.expressions.forEach(item => {
          item.entities.push(this.addSlo)
        })
        this.addSlo = {
          start: -1,
          end: -1,
          value: '',
          entity: '',
          chinese_name: '',
          dict: '',
          dict_id: '',
          required: false,
          ask_query: []
        }

      },
      //点击添加槽位值信息
      changeSlotinfo(key, val) {
        this.addSlo.value = '#' + key + '$' + val
        this.addSlo.entity = val
        this.valueShow = false

      },
      // 添加追问语句
      additionalF(item) {
        if (!item.required) return
        this.additionalList = []
        this.additionalItem = item
        this.additionalVisible = true
        this.addItional(item)
      },
      //添加追问语句到列表展示
      addItional(item) { // 回车添加到列表时
        if (this.additional.length > 50) {
          this.$message.error('追问语句仅支持50字符以内')
          return
        }
        if (item.ask_query) {
//          this.additionalList = item.ask_query
          this.additionalList = JSON.parse(JSON.stringify(item.ask_query))
        }
        this.itemDict = item.dict
        if (!this.additional) return
          this.additionalList.push(this.additional)
          this.additional = ''

      },
      removeItional(n) { //删除模态框中追问语句列表中的某一项
        this.additionalList.splice(n, 1)
//        if (!this.additionalItem.ask_query) this.additionalItem.ask_query = []
//        this.additionalItem.ask_query = [...new Set(this.additionalItem.ask_query.concat(this.additionalList))]
      },
      determine() {// 保存添加的追问语句
//        this.additionalList.push(this.additional)
        if (!this.additionalItem.ask_query) this.additionalItem.ask_query = []
        this.additionalItem.ask_query = this.additionalList
//        this.additionalItem.ask_query = [...new Set(this.additionalItem.ask_query.concat(this.additionalList))]
//        this.tableData.expressions.forEach(item => {
//          item.entities.forEach((val, index) => {
//            if (val.ask_query) {
//              val.ask_query = [...new Set(val.ask_query.concat(this.additionalList))]
//            } else {
//              val.ask_query = []
//              val.ask_query = [...new Set(val.ask_query.concat(this.additionalList))]
//            }
//          })
//        })
        this.additionalList = []
        this.additionalVisible = false
      },
      async addIntents() { //创建意图
        this.saveStatus = true
        let regName = /[^\u4e00-\u9fa5]/g
        let regIntent = /[^0-9a-zA-Z_]/g
          this.$refs.rules.validate((valid) => {})
        if (regName.test(this.tableData.chinese_name) || this.tableData.chinese_name.length < 2 || this.tableData.chinese_name.length > 50) {
//          this.$message({message: '请填写正确意图中文名,仅中文2~50字符', type: 'error'})
          this.$root.scroll_top()
          this.saveStatus = false
          return
        } else if (regIntent.test(this.tableData.intent) || this.tableData.intent.length < 2 || this.tableData.intent.length > 50) {
//          this.$message({message: '请填写正确意图标识名，仅数字、字母、下划线', type: 'error'})
          this.$root.scroll_top()
          this.saveStatus = false
          return
        }
        // 将槽位集合根据槽位标识相同添加到对应的表达式下
        this.entitiesList.forEach((item, index) => {
          for (let i = 0; i < this.tableData.expressions.length; i++) {
            var cur = this.tableData.expressions[i]
            cur.entities.forEach(val => {
              if (val.entity == item.entity) {
                val.ask_query = item.ask_query
                val.required = item.required
              }
            })
          }
//          this.tableData.expressions.forEach(item => {
//            item.entities.push(this.addSlo)
//          })
        })
        if (this.dialogueShow == false) {
          this.tableData.multi_conversation = []
        }
        this.$message.info('用户模型训练中···')
        let res = await addIntentsApi(JSON.stringify(this.tableData))
        if (res.data.code == 200) {
          if (res.data.data.error) {
            this.saveStatus = false
              if (res.data.data.error == 1) {
              this.$message({message: '意图识别名重复', type: 'error'})
              this.$root.scroll_top()
              return
            } else if (res.data.data.error == 2) {
              this.$message({message: '意图中文名重复', type: 'error'})
              this.$root.scroll_top()
              return
            } else if (res.data.data.error == 3) {
              this.$message({message: '意图中文名或意图识别名重复', type: 'error'})
              this.$root.scroll_top()
              return
            }
          } else {
            this.$message({message: '保存意图成功', type: 'success'})
            this.saveStatus = false
          this.$router.push(`/editIntention?skillId=${this.skill_id}&intent_id=${res.data.data.intent_id}`)
          }
        } else {
          this.saveStatus = false
          this.$message({message: '当前网络状况异常，请稍后再试', type: 'error'})
        }
      },
      dictHide() {
        this.dicShow = false
        this.valueShow = false
        this.slotsFlag = false
        $('.testWhole').animate({'left': 115+'px'},400)
      },
      handleCurrentChange(skip) {
        this.c_page = skip
        this.page = this.tableData.expressions.slice((skip - 1) * 5, skip * 5)

      },
      handleChange (scope) {
        let n = Number(scope.max_inherited_distance)
        if (isNaN(n)) {
          scope.max_inherited_distance = 5
        }
        if (n < 0) {
          scope.max_inherited_distance = 0
        } else if (n > 20) {
          scope.max_inherited_distance = 20
        }

      },
      reduceCount(scope) {
        if (scope.max_inherited_distance <= 0) {
          return
        }
        scope.max_inherited_distance--
      },
      addCount (scope) {
        if (scope.max_inherited_distance >= 20) {
          return
        }
        scope.max_inherited_distance++
      },
      deleteDialogue(index) {
        this.$confirm('是否删除此对话?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.checkIntent = this.checkIntent.filter(item => {
            return item != this.tableData.multi_conversation[index].prepositive_intent
          })
          this.tableData.multi_conversation.splice(index, 1)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      async intents() {
        let res = await getIntentsApi(this.skill_id)
        if (res.data.code == 200) {
//          this.tableData = res.data.data
          this.prepositive_intent = res.data.data
//          console.log(res.data.data);
        } else {
          this.$message({message: '获取意图列表失败', type: 'error'})
        }

      },
      async getPrepositive() {
        let res = await getPrepositiveApi(this.skill_id)
//        console.log(res.data.data);
        if (res.data.code == 200) {
          this.prepositive_intent = res.data.data
        } else {
          this.$message({message: '获取前置意图失败', type: 'error'})
        }
      },
      // 添加多轮对话
      add_multi() {
        let obj = {
          prepositive_intent: '',
          max_inherited_distance: 5,
          output_intent: false
        }
        this.tableData.multi_conversation.push(obj)
      },
      //查询前置意图槽位信息列表
      async searchValue(e) {
        this.valueShow = true
        this.seaDicL = e.pageX
        this.seaDicT = e.pageY
        let needIntents = []
        this.tableData.multi_conversation.forEach(item => {
          if (item.prepositive_intent) {
            needIntents.push(item.prepositive_intent)
          }
        })
        let res = await needIntentApi(this.skill_id, qs.stringify({need_intents: needIntents}))

        if (res.data.code == 200) {
          this.options = res.data.data
//        console.log(this.options);
        }

//    }
      },
      // 检查添加槽位，槽位标识是否是可编辑状态，（有重复不可编辑）
      checkRepeat: function (entity) {
        for (let i = 0; i < this.entitiesList.length; i++) {
          if (this.entitiesList[i].entity == entity) {
            return true
          }

        }
      },
      tabindexNumChange(){
        this.tabindexNum = "-1"
      },
    },
    mounted() {
      document.addEventListener('click', this.dictHide)
    },
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  #createIntention {
    background: #f7f7f7;
    list-style: none;
    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to{
      opacity: 0;
    }
    input {
      /*width: 167px;*/
      height: 28px;
      line-height: 28px;
      border-radius: 14px;
    }
    .center-tbody {
      text-align: center;
      .input_text {
        width: 100%;
      }
    }
    .el-form {
      input {
        width: 420px;
      }
    }
    .input_text {
      /*border:none;*/
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;
    }
    button {
      height: 28px;
      position: relative;
      top: 5px;
      span {
        position: relative;
        top: -5px;
      }
    }
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 900;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
    table{
      border: 1px solid #ebeef5;
      thead{
        background: #f9fafc;
      }
      td{
        padding: 14px;
      }
    }
    #intentionInfo {
      background: #fff;
      .intentionContainer {
        padding: 10px 30px 30px 30px;
        height: 145px;

      }
    }
    #oftenInfo {
      background: #fff;
      margin-top: 26px;
      padding-bottom: 30px;
      .el-input {
        width: 300px;
        margin-right: 50px;
      }
      #input3 {
        width: 100%;
        margin: 30px 15px 0 30px;
      }
      ul {
        li {
          padding: 0;
          .oftenInfo_title {
            line-height: 46px;
            /*border:1px solid #e4ebf3;*/
            color: #4f4f4f;
            font-size: 14px;
            padding: 0 20px;
            word-wrap:break-word
          }
          table {
            margin: 0;
            /*display: none;*/
            tr{
              &:hover{
                background: #f9fafc;
              }
            }
            td {
              position: relative;
              input {
                position: absolute;
                left: 0;
                top: 0;
                padding: 10px;
                border: none;
                outline: none;
              }
            }
          }

        }
      }

      button {
        height: 28px;
        position: relative;
        top: 6px;
        span {
          position: relative;
          top: -6px;
        }
      }
    }
    .addSlots {
      position: relative;
      top: -2px;
      span {
        position: relative;
        top: -2px;
      }
    }
    #add_slots {
      background: #fff;
      margin-top: 26px;
      table {
        margin: 0;
        tr{
          &:hover{
            background: #f9fafc;
          }
        }
        td {
          position: relative;
          input {
            position: absolute;
            left: 19px;
            top: 15px;
            padding: 10px;
            border: 1px solid #ddd;
            outline: none;
            height: 28px;
            line-height: 28px;
          }
        }
      }
      input {
        width: 90%;
      }
    }
    #intention_confirm {
      background: #fff;
      margin-top: 26px;
      padding-bottom: 20px;
      .intent_container{
        display: flex;
        .add_intent_list{
          flex:1;
          margin-right:5px;
        }
        .list_intent{
          flex:5;
          padding-top: 5px;
          .intention_list {
            display: inline-block;
            width: 210px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            height: 28px;
            line-height: 28px;
            border-radius: 14px;
            border: 1px solid #eee;
            padding: 0 20px;
            margin: 0 10px 10px 0;
            position: relative;
            i {
              position: absolute;
              right: 5px;
              top: 4px;
            }
          }
        }
      }
    }
    #dialogue {
      background: #fff;
      margin-top: 26px;
      padding-bottom: 50px;
      .el-table__body-wrapper{
        overflow: hidden;
      }
      .el-table{
        thead{
          background: #f9fafc;
        }
        td{
          padding: 4px;
        }
      }
      .el-table--border::after, .el-table--group::after, .el-table::before{
        z-index: 0;
      }
    }
    #Preservation {
      margin: 20px auto;
      height: 34px;
      line-height: 18px;
    }
    .text-center {
      input {
        text-align: center;
      }
    }
    .searchDic {
      width: 300px;
      border: 1px solid #eee;
      border-radius: 4px;
      position: absolute;
      background: #fff;
      padding: 10px;
      margin-top: -130px;
      margin-right: 150px;
      input {
        width: 100%;
        border-radius: 0;
        border: none;
        border-bottom: 1px solid #eee;
        &:hover {
          border-bottom: 1px solid #409EFF;
        }
      }
      ul {
        list-style: none;
        height: 180px;
        overflow-y: scroll;
        li {
          color: #2e4d79;
          padding-left: 20px;
          height: 30px;
          line-height: 30px;
          &:hover {
            background: #f9fafc;
            cursor:pointer;
          }
        }
      }

    }
    .searchValue {
      width: 300px;
      border: 1px solid #eee;
      border-radius: 4px;
      position: absolute;
      background: #fff;
      padding: 10px;
      margin-top: -130px;
      margin-right: 150px;
      #valueSlots {
        list-style: none;
        height: 180px;
        overflow-y: scroll;
        li {
          display: flex;
          text-align: center;
          padding: 5px 0;
          &:hover {
            background: #f9fafc;
            cursor:pointer;
          }
          div {
            width: 200px;
          }
          ol {
            width: 100%;
            li {
              width: 100%;
              text-align: center;
              padding: 5px 0;
              &:hover {
                color: #409eff;
              }
            }
          }
        }
      }
    }

    .deleteIcon {
      font-size: 20px;
      color: #ccc;
    }
    .deleteIcon:hover {
      color: #f56c6c;
    }
    .addItional {
      border-radius: 8px;
      .el-dialog__header{
        border-bottom: 1px dashed #eee;
        padding: 17px 30px;
        .el-dialog__title{
          font-size: 16px;
        }
      }
      .el-dialog__headerbtn {
        position: absolute;
        right: 15px;
        top: 15px;
        .el-dialog__close{
          font-size: 30px;
        }
      }
      .el-dialog__body {
        padding-top: 10px;
      }
      ul {
        list-style: none;
        padding-top: 20px;
        width: 97%;
        li {
          color: #002b42;
          padding: 0 10px;
          line-height: 25px;
          .deleteIcon {
            margin-top: 3px;
          }
          &:hover {
            background: #f9fafc;
            cursor:pointer;
          }
        }
      }
    }
    .intentSavebtn {
      width: 90px;
      height: 32px;
      i {
        margin-top: -10px;
        vertical-align: middle;
      }
    }
    .itentconfirm {
      .el-dialog__header {
        .el-dialog__headerbtn {
          position: absolute;
          right: 10px;
        }
        .el-dialog__body {
          .el-input {
            width: 100%;
            .el-input__inner {
              width: 100%;
            }
          }
        }
      }
    }
    .blurIcon {
      color: #7abaf1;
    }
    .el-form-item {
      position: relative;
      .blurIcon {
        color: #7abaf1;
        position: absolute;
        left: -18px;
      }
    }
    .heightcolumn {
      margin: 10px 0;
    }
    .countBox {
      position: relative;
      input {
        width: 100px;
        text-align: center;
      }
      .count {
        width: 14px;
        height: 14px;
        position: absolute;
        top: 2px;
        left: 50%;
        cursor: pointer;
        z-index: 99;
        &:hover{
          color: #409eff;
        }
      }
      .countLeft{
        margin-left: -40px;
      }
      .countRight {
        top: 2px;
        margin-left: 27px;
      }
    }
    .el-form-item__label{
      padding-right: 20px;
    }
    #info-more{
      tbody{
        border-right: 1px solid #ebeef5;
      }
    }
    .table tbody tr td{
      border-bottom:1px solid #ebeef5;
    }
    .el-table th{
      background: #f9fafc;
      border-bottom: none;
      color: #000;
      div{
        line-height: 20px;
      }
    }
    .table thead tr{
      td{
        border-bottom:1px solid #ebeef5;
      }
      th.text-center{
        border-bottom:1px solid #ebeef5;

      }
    }
    .add-p{
      border: 1px solid #ebeef5;
      border-top: none;
      padding: 13px;
    }
    .icon-wenhao{
      cursor: pointer;
      font-weight: normal;
    }
  }
  #boxCard{
    margin:0;
    padding:0;
    max-height:200px;
    overflow-y: scroll;
    .el-card__body{
      padding:5px;
    }
    .text{
      padding: 3px 10px;
      cursor:pointer;
      &:hover{
        background: #f9fafc;
      }
    }
  }
  #forthwithTest{
    position: fixed;
    right:0;
    top:20%;
    .testSmall{
      width: 44px;
      height: 110px;
      background:#0091ed;
      color:#fff;
      text-align: center;
      border-radius: 8px 0 0 8px;
      font-size: 14px;
      padding-top:12px;
      cursor: pointer;
      .tes_c{
        width: 16px;
        margin:0 auto;
        .testTxt{
          display: inline-block;
          line-height: 16px;
        }
      }

    }
    .testWhole{
      position: absolute;
      left:215px;
      top:0;
      width: 260px;
      height: 520px;
      background:#f6f6f6;
      border-radius: 8px;
      overflow: hidden;
      .whole_test{
        height: 40px;
        line-height:40px;
        background:#077eec;
        color:#fff;
        font-size: 14px;
        text-align: center;
      }
      .whole_height{
        height:470px;
        width: 108%;
        overflow-y: scroll;
        .whole_query{
          text-align: center;
          input{
            width: 190px;
            height: 28px;
            line-height: 28px;
            outline: none;
            border:1px solid #ddd;
            padding-left:10px;
            font-size: 12px;
          }
        }
        .whole_con{
          width: 220px;
          margin:0 auto;
          font-size: 12px;
          .whole_con1{
            padding-top:15px;
            p{
              height: 14px;
              line-height: 14px;
              font-weight: 600;
              border-left:1px solid #6aa3ef;
              padding-left:5px;
            }
            div{
              width: 220px;
              word-break: break-all;
              padding-left:15px;
              line-height: 18px;
            }
          }
        }
      }
      .Microphone{
        transform: scale(0.7);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skill/intention/CreateIntention.vue